var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav-inner_nir",class:( _obj = {}, _obj[_vm.curTheme] = true, _obj )},[_c('div',{staticClass:"nir_menu"},_vm._l((_vm.linksLoc),function(l,i){return _c('router-link',{key:("nir-link-" + i),staticClass:"nir_link",class:{ active: i === _vm.activeI },attrs:{"to":l.url}},[_vm._v("\n      "+_vm._s(l.text)+"\n    ")])}))])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca2c529","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavInner.vue
// module id = null
// module chunks = 